window.initDeliveryMessage = function(container, variantId) {
  if (!container || !variantId) {
    return;
  }
  
  function decodeHTML(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }
  
  function updateMessage() {
    const deliveryElement = container.querySelector('[data-delivery-message]');
    if (!deliveryElement) {
      return;
    }

    const translationsElement = document.querySelector('[data-translations]');
    
    if (!translationsElement) {
      return;
    }

    try {
      const translations = JSON.parse(translationsElement.textContent);
      const inventoryData = JSON.parse(document.querySelector('.js-inventory-data').textContent);
      const variantInventory = inventoryData.find(v => v.id === parseInt(variantId));
      
      const isOutOfStock = variantInventory && (
        variantInventory.inventory_quantity === 0 || 
        !variantInventory.available
      );

      const now = new Date();
      const spainTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
      const hour = spainTime.getHours();
      const minutes = spainTime.getMinutes();
      const isBeforeDeadline = hour < 19;

      let startDate = new Date();
      let endDate = new Date();
      let message = '';

      if (isOutOfStock) {
        startDate.setDate(startDate.getDate() + 7);
        endDate.setDate(endDate.getDate() + 10);
      } else if (isBeforeDeadline) {
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(startDate.getDate() + 3);
      } else {
        startDate.setDate(startDate.getDate() + 2);
        endDate.setDate(startDate.getDate() + 4);
      }

      if (isBeforeDeadline) {
        const remainingHours = 18 - hour;
        const remainingMinutes = 60 - minutes;
        message = decodeHTML(translations.general.delivery.buy_before)
          .replace('%(hours)s', remainingHours)
          .replace('%(minutes)s', remainingMinutes);
      } else {
        message = decodeHTML(translations.general.delivery.receive_between);
      }

      const formatDate = (date) => {
        return translations.general.delivery.date_format
          .replace('%(day)s', date.getDate())
          .replace('%(month)s', translations.months[date.getMonth()]);
      };

      message += ` ${formatDate(startDate)} y ${formatDate(endDate)}`;
      
      deliveryElement.innerHTML = message;
    } catch (error) {
      console.error('Error processing delivery message:', error);
    }
  }

  updateMessage();

  return () => {
  };
}; 